// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ButtonView_widget-card__footer-buttons_FrgASq{display:flex!important;gap:20px!important;align-items:center!important;margin-bottom:20px!important}@media screen and (max-width:370px){.ButtonView_widget-card__footer-buttons_FrgASq{gap:15px!important;margin-bottom:15px!important}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
